import { Component, input, inject } from '@angular/core';

import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TableRowData } from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';
import { EVENT_TYPE_TRANSLATION_PREFIX } from '@app/shared/services/view-configs/filter-key-creator';

@Component({
    selector: 'app-translated-text-display',
    template: `{{ getTranslatedValue() }}`,
    standalone: true,
    imports: [TranslateModule],
})
export class TranslatedTextDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    parentRow = input<TableRowData>();

    private translateService = inject(TranslateService);

    getTranslatedValue(): string {
        if (!this.value()) {
            return '';
        }

        // The same key the filter options are built from, so cell and filter
        // always show the user the same wording.
        const translationKey = EVENT_TYPE_TRANSLATION_PREFIX + this.value();
        return this.translateService.instant(translationKey);
    }
}
